<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
        <headbar />
      </a-layout-header>
      <a-layout-content>
        <div :style="{ background: '#fff', padding: '0', minHeight: '380px' }">
          <router-view :key="key" />
        </div>
      </a-layout-content>
      <a-layout-footer :style="{ textAlign: 'center', 'font-size': '16px' }">
        <a-row type="flex" justify="center">
          <a-col :sm="24" :md="8">
              <div style="height:80px;">
                扫码关注微信公众号 
                <img style="height:80px;width:auto;" src="@/assets/qrcode.jpg">
              </div>
          </a-col>
          <a-col :sm="24" :md="8">
            <a-row style="margin-top:24px;">太仓港国际货运有限公司 ©2020 Created by TPIT</a-row>
          </a-col>
          <a-col :sm="24" :md="8">
            <a-row style="margin-top:24px;">公司地址：太仓市郑和路309号太仓发展大厦9楼</a-row>
            <a-row>联系电话：0512-53998108</a-row>
            <a-row>业务联系：0512-53562531</a-row>
          </a-col>
        </a-row>
        <a-row type="flex" justify="center">
          <a target="_blank" href="http://www.beian.miit.gov.cn/" style="color:#fff;">
            网站备案号：苏ICP备17061173号-1
          </a>   
        </a-row>   
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import Headbar from './components/Navbar'

export default {
  name: 'Layout',
  components: { Headbar },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style>
#components-layout-demo-basic {
  text-align: center;
  margin: 0 auto;
}
#components-layout-demo-basic .ant-layout-footer {
  line-height: 1.5;
  background: rgba(0, 22, 41, 1);
  color: #fff;
}
#components-layout-demo-basic .ant-layout-content {
  /* background: rgba(16, 142, 233, 1);
  color: #fff; */
  min-height: 900px;
  line-height: 2;
  background: #fff;
  padding-top: 64px;
  margin: 0 auto;
  max-width: 1600px;
}
/* #components-layout-demo-basic > .ant-layout {
  margin-bottom: 48px;
} */
#components-layout-demo-basic > .ant-layout:last-child {
  margin: 0;
}
</style>